import { html, slotted } from "@microsoft/fast-element";
/**
 * The template for the {@link @fabric-msft/fabric-web#(OptionGroup:class)} component.
 *
 * @public
 */
export function optionGroupTemplate() {
    return html `
    <template ?disabled="${(x) => x.disabled}">
      <div class="label">${(x) => x.label}</div>
      <div class="options" role="presentation">
        <slot ${slotted("slottedOptions")}></slot>
      </div>
    </template>
  `;
}
export const template = optionGroupTemplate();
//# sourceMappingURL=option-group.template.js.map